import {FeatureName} from '@contentlab/types/project';

export const HOME_CONTENT_MAX_WIDTH = 974;
export const PROJECTS_CONTENT_MAX_WIDTH = 1400;

export const PROJECT_CARDS_ROW_GAP = 40;
export const PROJECT_CARDS_COLUMN_GAP = 24;

export const RECENT_PROJECTS_CARDS_GAP = 24;

export const DEFAULT_DEBOUNCE_DELAY = 500; // 0.5 seconds

// this key is used to store a pending draft projectId in the localStorage
// it is set when a user clicks Generate inside a feature and if he does not have sufficient credits
// then they are redirected to the pricing page which in turn will lead to an external web payments page
// after returning to the app we check if this key is present (check is done on the Home component) and if it does:
// we redirect to the feature page and load the project
export const DRAFT_PROJECT_ID_KEY = 'draftProjectId';

export const PROJECT_ID_SEARCH_PARAM_KEY = 'projectId';

// This is set here as for now we don't have a way to get the free trial token quantity from the backend
export const FREE_TRIAL_TOKEN_QUANTITY = 12;

export const FEATURE_BEST_PRACTICES_LOCALE_KEY = {
  [FeatureName.REFORMATTING]: 'Clear, steady footage works best.',
  [FeatureName.AI_DUBBING]:
    'Face the camera, keep the mouth visible, and record in a quiet space.',
  [FeatureName.REPHRASING]:
    'Use clear speech with natural pauses and minimal background noise.',
  [FeatureName.CAPTIONS]:
    'Use one speaker at a time, complete sentences, and no singing for best caption accuracy.',
  [FeatureName.AI_AVATAR]: 'Choose a clear clip with some empty space.',
  [FeatureName.UPSCALE]: undefined,
};
